// Геометрия примитивов SVG для редактора.
//
// CorelDRAW отдаёт часть деталей не путём, а примитивом: планка воротника
// приходит как <rect>. Редактор строил контур только из атрибута d, поэтому
// такая деталь молча не рисовалась — кнопка есть, холст пуст, цвет задать
// некуда (клип пустой). Точки считаем ровно так же, как сервер
// (SvgGeometry.shape_points), иначе клип в редакторе разъедется с раскладкой.

export const ELLIPSE_SEGMENTS = 64   // столько же, сколько у SvgGeometry

// Плоский массив [x0,y0,x1,y1,…] для примитива; null — для <path> и прочего.
export function shapePoints(el) {
  const num = (name) => parseFloat(el.getAttribute(name)) || 0

  switch (el.tagName) {
    case "polygon":
    case "polyline":
      return (el.getAttribute("points") || "").trim().split(/[\s,]+/).filter(Boolean).map(Number)
    case "rect": {
      // Скругление (rx/ry) игнорируем — как и сервер: важнее совпадение с раскладкой
      const x = num("x"), y = num("y"), w = num("width"), h = num("height")
      return w > 0 && h > 0 ? [x, y, x + w, y, x + w, y + h, x, y + h] : null
    }
    case "circle":
      return ellipsePoints(num("cx"), num("cy"), num("r"), num("r"))
    case "ellipse":
      return ellipsePoints(num("cx"), num("cy"), num("rx"), num("ry"))
    default:
      return null
  }
}

export function ellipsePoints(cx, cy, rx, ry) {
  if (rx <= 0 || ry <= 0) return null

  const pts = []
  for (let k = 0; k < ELLIPSE_SEGMENTS; k++) {
    const a = (2 * Math.PI * k) / ELLIPSE_SEGMENTS
    pts.push(cx + rx * Math.cos(a), cy + ry * Math.sin(a))
  }
  return pts
}

// d замкнутого контура по плоскому массиву точек.
export function pointsToPathD(pts) {
  let d = `M${pts[0]},${pts[1]}`
  for (let i = 2; i < pts.length; i += 2) d += `L${pts[i]},${pts[i + 1]}`
  return `${d}Z`
}
